import React from 'react';
import Experiences from '../../data/Experiences';
import VideoCard from './_shared/VideoCard';
import SelectionCard from './_shared/SelectionCard';
import SelectionProvider from '../../contexts/SelectionContext';

const ExperiencesCards = () => {
    return (
        <div className="flex flex-col lg:flex-row lg:space-x-5">
            <SelectionProvider selectionList={Experiences}>
                <SelectionCard
                    title="Our AR experiences"
                    // text="FanCollex allows fans to enjoy unique moments and collect data thanks to our special AR features."
                    text="Take passion to the next level with our special AR features."
                />
                <VideoCard />
            </SelectionProvider>
        </div>
    );
};

export default ExperiencesCards;
